<template>
  <div class="base-confirmation-modal">
    <p v-html="text" />
    <div class="flex-center m-t-16">
      <button @click="handleNo" class="m-r-16">
        NO
      </button>
      <button class="green-btn"
              @click="handleYes">
        YES
      </button>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  const { commit } = useStore()

  const props = defineProps({
    text: String,
    data: [Object, Array]
  })
  const emit = defineEmits(['yes', 'no'])

  function handleYes () {
    emit('yes', {data: props.data})
  }

  function handleNo () {
    emit('no')
    commit('SET_MODAL', false)
  }
</script>

<style lang="scss">
  .base-confirmation-modal {
    @media only screen and (min-width: 0) {
      p {
        font-size: 1.8rem;
        line-height: 1.5;
        margin-bottom: 24px;
      }
      button {
        padding: 10px 24px;
        border-radius: 8px;
        font-size: 1.6rem;
        font-weight: 600;
        cursor: pointer;
        border: none;
        background-color: #f0f0f0;
        color: #1a1a1a;
        &:hover {
          background-color: #e4e4e4;
        }
        &.green-btn {
          background-color: #e5484d;
          color: #fff;
          &:hover {
            background-color: #d03a3f;
          }
        }
      }
    }
  }
</style>
